/** See `src/i18n/locales/en/manage.ts`. */
export const manage = {
  backToApp: 'Retour à l’application',
  sections: {
    companies: {
      label: 'Entreprises',
      items: {
        companies: 'Entreprises',
        pilots: 'Pilotes',
      },
    },
    people: {
      label: 'Personnes',
      items: {
        users: 'Tous les utilisateurs',
        linkIdentities: 'Lier des identités',
        admins: 'Administrateurs',
      },
    },
    audit: {
      label: 'Audit',
      items: {
        audit: 'Journal d’audit',
      },
    },
    subscriptions: {
      label: 'Abonnements',
      items: {
        config: 'Provider configuration',
        products: 'Produits & fournisseurs',
        userLedger: 'Registre des utilisateurs',
      },
    },
    system: {
      label: 'Système',
      items: {
        statistics: 'État des statistiques & recalcul',
        requests: 'Requêtes API',
      },
    },
    support: {
      label: 'Support',
      items: {
        tickets: 'Tickets',
      },
    },
    overview: {
      label: 'Aperçu',
      items: {
        overview: 'KPI',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'État des statistiques & recalcul',
      note: 'L’état des statistiques et la commande de recalcul sont un plan à part — cette entrée de menu réserve la place, l’écran n’est pas construit en phase 1.',
    },
  },
  usersAll: {
    title: 'Tous les utilisateurs',
    linkIdentities: 'Lier des identités',
    empty: 'Aucune identité n’existe encore.',
    name: 'Nom',
    email: 'E-mail',
    language: 'Langue',
    login: 'Connexion',
    yes: 'oui',
    no: 'non',
    view: 'Voir',
    rowsLabel: 'les utilisateurs',
  },
  linkIdentities: {
    title: 'Lier des identités en double',
    lead: 'L’alias continue d’exister mais pointe vers la principale. Sauf si vous êtes administrateur de la plateforme, l’une des deux doit être sans connexion, et l’identité avec connexion devient la principale — le serveur le vérifie, quel que soit le choix fait ici.',
    candidatesLabel: 'les personnes que vous administrez',
    needTwo: 'Il vous faut au moins deux personnes dans votre périmètre pour lier.',
    aliasLabel: 'Alias (cette identité devient le pointeur)',
    primaryLabel: 'Principale (l’identité qui subsiste)',
    choose: 'Choisir…',
    hasLogin: '(a une connexion)',
    noLogin: '(sans connexion)',
    link: 'Lier',
    cancel: 'Annuler',
  },
  erase: {
    completedTitle: 'Effacement terminé',
    completedText:
      'L’identité est effacée. Le journal d’audit est pseudonymisé, pas supprimé ; les identités liées subsistent avec leur pointeur réinitialisé.',
    departmentsWithoutAdmin: 'Départements restés sans administrateur : {{names}}',
    measurementsNotDeleted:
      'Les mesures du service d’ingestion n’ont PAS été supprimées — cette capacité n’existe pas encore là-bas. Suivez cela en dehors du tableau de bord.',
    backToUsers: 'Retour aux utilisateurs',
    title: 'Effacer cette personne',
    lead: 'Ceci supprime irréversiblement et définitivement l’identité {{userId}} : sa ligne utilisateur, ses adhésions, ses consentements et ses droits. Les identités liées subsistent ; les données provenant de Gengee restent ; le journal d’audit est pseudonymisé. Tapez {{confirmWord}} pour confirmer.',
    confirmWord: 'ERASE',
    confirmationLabel: 'Confirmation',
    erasePermanently: 'Effacer définitivement',
    cancel: 'Annuler',
  },
  requests: {
    title: 'Requêtes API',
    lead: 'Les requêtes journalisées de l’API d’ingestion pour une source, les plus récentes en premier, optionnellement limitées à une fenêtre temporelle.',
    filterSource: 'Filtrer par source',
    sourcePlaceholder: 'id de source',
    filterFrom: 'De',
    filterTo: 'À',
    filter: 'Filtrer',
    enterSourceHint: 'Saisissez un id de source pour charger son journal de requêtes.',
    empty: 'Aucune requête journalisée pour cette source et cette fenêtre.',
    when: 'Quand',
    method: 'Méthode',
    path: 'Chemin',
    status: 'Statut',
    rowsLabel: 'les requêtes',
  },
} as const;
